import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { RefreshOutlined } from '@mui/icons-material';
import React from 'react';

type Props = {
  title?: string;
  message?: string;
  onRefresh?: () => void;
};

function FallbackMessage({
  title = 'Unable to Load Enterprise Dashboards',
  message = "We're sorry — something went wrong while loading your enterprise dashboards.",
  onRefresh,
}: Props) {
  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      window.location.reload();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '90vh',
        width: '100%',
        gap: 2,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 500,
          textAlign: 'center',
          mb: 1,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          color: '#111927',
          maxWidth: '500px',
          mb: 3,
        }}
      >
        {message}
        <br />
        <br />
        Please try refreshing the page, or let us know via Intercom if the issue continues.
      </Typography>
      <Button
        variant="contained"
        startIcon={<RefreshOutlined />}
        onClick={handleRefresh}
        sx={{
          borderRadius: 2,
          textTransform: 'none',
          px: 3,
          py: 1,
        }}
      >
        Refresh
      </Button>
    </Box>
  );
}

export default FallbackMessage;
